import ModalCoachCancelComplete from './ModalCoachCancelComplete';

export { type Props } from './ModalCoachCancelComplete';

export default ModalCoachCancelComplete;
